// extracted by mini-css-extract-plugin
module.exports = {"StudiesProgrammeForm":"style_StudiesProgrammeForm__AlsrE","wrapper":"style_wrapper__krpiz","column":"style_column__2HS7u","wrapperColumn":"style_wrapperColumn__PUhvI"};